let instanceConfig = {};
let currentLang = "de";

const get = function() {
  return Promise.resolve(instanceConfig);
};

function setCurrentLang(lang) {
  if (lang) {
    window.localStorage.setItem('lang', lang);
    currentLang = lang;
  }
}

function getCurrentLang() {
  if (!window.localStorage.getItem('lang')) {
    setCurrentLang(currentLang);
  }

  return window.localStorage.getItem('lang');
}

export default {
  get,
  getCurrentLang,
  setCurrentLang,
};



// WEBPACK FOOTER //
// ./src/utils/instanceConfig.js